import { useMemo } from "react";

import { useCustomTypes } from "../helpers/use_custom_types";

export const useSkillsType = () => {
  const { getCustomTypeByName } = useCustomTypes();

  return useMemo(() => getCustomTypeByName("skills"), [getCustomTypeByName]);
};
